import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {useHttp} from "../../hooks/http.hook";
import {AuthContext} from "../../context/AuthContext";
import EditOrgWithDaData from "../Modals/EditOrgWithDaData";
import OrgPage from "../OrgPage";

OrganizationHistoryTemplate.propTypes = {
    getOrgHistoryAPI: PropTypes.string.isRequired,
    tableModel: PropTypes.object,
    breadCrumbsItems: PropTypes.array.isRequired,
    filterBarConf: PropTypes.object,
    addNewStudyConfig: PropTypes.shape({
        show: PropTypes.bool,
        API: PropTypes.string
    }),


};

function OrganizationHistoryTemplate(props) {
    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const baseURL = process.env.REACT_APP_BASE_URL

    const [refresh, setRefresh] = useState(false)
    const [editModal, showEditModal] = useState()
    const [modalId, setModalId] = useState()


    const addNewStudy = async () => {
        const url = `${baseURL}${props.addNewStudyConfig.API}`
        const {data, status} = await request(url, 'POST', null, {Authorization: `Bearer ${token.token}`})
        status >= 200 && status < 300 ? setRefresh(!refresh) : console.log()
    }
    const editHistory = (data) => {
        setModalId(data)
        showEditModal(true)
    }

    const closeHandler = () => {
        showEditModal(false)
        setRefresh(!refresh)
    }
    const tableModel = {...props.tableModel}

    tableModel.haveToShow[0].typeData.onClick = editHistory

    return (
        <>
            {editModal
                ? <EditOrgWithDaData id={modalId} closeHandler={closeHandler}
                                     url={""}/>
                : ''}

            <OrgPage
                url={`${baseURL}${props.getOrgHistoryAPI}`}
                refresh={refresh}
                firstRow={tableModel.firstRow}
                haveToShow={tableModel.haveToShow}
                breadCrumbsItems={props.breadCrumbsItems}

                addOrg={{
                    patient: props.addNewStudyConfig.show,
                    onClick() {
                        addNewStudy()
                    }
                }}

                filterBarButtons={{
                    downloadTemplate: {
                        show: true,
                        url: 'http://89.223.125.89/shablon.csv'
                    }
                }}
                filterFieldsConf={props.filterBarConf}
            />
        </>
    );
}


export default OrganizationHistoryTemplate;

OrganizationHistoryTemplate.defaultProps = {
    filterBarConf: {
        date: true,
        base: true,
        period: true,
    },
    tableModel: {
        haveToShow: [
            {id: 'organization_info', idArr: ['id'], type: 'linkToOrgPatients', typeData: {show: 'name'}},
            {id: 'document', type: 'uploadLists', idArr: ['id'], typeData: {uploaded: 'uploaded'}},
            {id: 'createdAt'},
            {id: 'patientsCount'},
            {id: 'base'},
            {id: 'invitation'},
            {id: '_id', type: 'emailSend'},
        ],
        firstRow:
            [
                {title: 'Название', id: 'medName', sortFunction: function () {}},
                {title: 'Загрузить списки', id: 'uploadLists', sortFunction: function () {}},
                {title: 'Год', id: 'year', sortFunction: function () {}},
                {title: 'Исследований', id: 'research', sortFunction: function () {}},
                {title: 'Вид', id: 'place', sortFunction: function () {}},
                {title: 'Вызов', id: 'invitation', sortFunction: function () {}},
                {title: 'Печать', id: 'print', sortFunction: function () {}}
            ],
    },


};




